// eslint-disable-next-line import/no-anonymous-default-export
export default {
  title: 'Panels',
  subtitle: 'Manage hosting panels',
  addNew: 'New Panel',
  edit: 'Edit',
  panelName: 'Panel Name',
  panelType: 'Panel Type',
  url: 'URL',
  username: 'Username',
  password: 'Password',
  notes: 'Notes',
  status: 'Status',
  actions: 'Actions',
  noPanels: 'No panels defined yet',
  noPanelsDesc: 'Start by adding your first panel.',
  panelAdded: 'Panel successfully added',
  panelUpdated: 'Panel successfully updated',
  panelDeleted: 'Panel successfully deleted',
  fetchError: 'Panels could not be retrieved',
  addError: 'Panel could not be added',
  updateError: 'Panel could not be updated',
  deleteError: 'Panel could not be deleted',
  confirmDelete: 'Are you sure you want to delete this panel?',
  typeCpanel: 'cPanel',
  typePlesk: 'Plesk',
  typeDirectadmin: 'DirectAdmin',
  typeVestacp: 'VestaCP',
  typeOther: 'Other',
  paymentAnalysis: 'Payment Analysis',
  recurringPaymentsAnalysis: 'Recurring Payment Analysis'
};
